module.exports = __webpack_public_path__ + "img/Icon-file-plus.a90a656d.svg";